import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import store from './index';
export default {
  store: store,
  install: function install(Vue) {
    var vueInstance = Vue;
    vueInstance.prototype.$store = store();
  }
};